import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "../interfaceSettings.css";
import pic1 from "../assets/webp/Landing1.webp";
import pic2 from "../assets/webp/Landing2.webp";
import pic3 from "../assets/webp/Landing3.webp";
import pic4 from "../assets/webp/Landing4.webp";
import pic5 from "../assets/webp/Landing5.webp";
import pic6 from "../assets/webp/Landing6.webp";

const Landing = () => {

const navigate = useNavigate();

  // Reusable button that navigates to the authorization page
  const AuthButton = ({ label }) => {
    const handleClick = (e) => {
      // optional: prevent default if used inside <a> etc. not necessary here
      navigate("/authorization");
    };

    return (
      <button
        type="button"
        onClick={handleClick}
        className="btn btn-primary mt-3 btn-responsive btn-block"
        aria-label={`Go to ${label}`}
      >
        <i className="bi bi-chevron-right" aria-hidden="true"></i>{" "}
        <span>{label}</span>
      </button>
    );
  };

  return (
    <div className="container-xl">
      {/* Showcase Section */}
      <section id="showcase">
        <div className="container my-4">
          <div className="card shadow-sm">
            <div className="row align-items-center">
              <div className="col-md-6 text-center">
                <img
                  src={pic1}
                  alt="Aerial view of building B at Georgia Gwinnett College"
                  className="img-fluid rounded mx-auto"
                />
              </div>
              <div className="col-md-6 p-3 p-md-5">
                <h1>Walking Trails</h1>
                <p className="lead my-4" style={{ textAlign: "center" }}>
                  The Walking Trails App is a mobile application designed to
                  enhance the walking experience on Georgia Gwinnett College
                  (GGC) trails through interactive and educational content
                  focused on fitness, health, and wellness. This project is a
                  collaborative effort between ITEC students, who are
                  responsible for app development, and EXSC students, who create
                  the content.
                </p>
                <AuthButton label="Sign In" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Body Weight Exercises Section */}
      <section id="exercise">
        <div className="container my-4">
          <div className="card shadow-sm">
            <div className="row align-items-center">
              <div className="col-md-6 text-center">
                <img
                  src={pic2}
                  alt="1 runner and 2 people pouring multicolored powder in a color fun run outside"
                  className="img-fluid rounded mx-auto"
                />
              </div>
              <div className="col-md-6 p-3 p-md-5">
                <h2>Body Weight Exercises</h2>
                <p className="lead" style={{ textAlign: "center" }}>
                  Try a variety of body-weight exercises to build strength and
                  endurance.
                </p>
                <AuthButton label="Exercises" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Proper Walking Techniques Section */}
      <section id="properWalkingTechniques">
        <div className="container my-4">
          <div className="card shadow-sm">
            <div className="row align-items-center">
              <div className="col-md-6 text-center">
                <img
                  src={pic3}
                  alt="Person smiling with bubbles on their hands and floating in the background"
                  className="img-fluid rounded mx-auto"
                />
              </div>
              <div className="col-md-6 p-3 p-md-5">
                <h2>Proper Walking Techniques</h2>
                <p className="lead" style={{ textAlign: "center" }}>
                  Learn techniques to improve your walking posture and
                  efficiency.
                </p>
                <AuthButton label="Proper Walking Techniques" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stretches For Walking Section */}
      <section id="stretchesForWalking">
        <div className="container my-4">
          <div className="card shadow-sm">
            <div className="row align-items-center">
              <div className="col-md-6 text-center">
                <img
                  src={pic4}
                  alt="Person smiling outside while carving a heart shape in a pumpkin"
                  className="img-fluid rounded mx-auto"
                />
              </div>
              <div className="col-md-6 p-3 p-md-5">
                <h2>Stretches For Walking</h2>
                <p className="lead" style={{ textAlign: "center" }}>
                  Enhance flexibility and prevent injuries with these essential
                  stretches.
                </p>
                <AuthButton label="Stretches For Walking" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nutrition and Hydration Section */}
      <section id="nutritionAndHydration">
        <div className="container my-4">
          <div className="card shadow-sm">
            <div className="row align-items-center">
              <div className="col-md-6 text-center">
                <img
                  src={pic6}
                  alt="3 people with bookbags walking outside together on the sidewalk"
                  className="img-fluid rounded mx-auto"
                />
              </div>
              <div className="col-md-6 p-3 p-md-5">
                <h2>Nutrition and Hydration</h2>
                <p className="lead" style={{ textAlign: "center" }}>
                  Fuel your body with the right nutrients and stay hydrated for
                  better performance.
                </p>
                <AuthButton label="Nutrition and Hydration" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Injury Prevention Section */}
      <section id="injuryPrevention">
        <div className="container my-4">
          <div className="card shadow-sm">
            <div className="row align-items-center">
              <div className="col-md-6 text-center">
                <img
                  src={pic5}
                  alt="Students sitting and walking outside of Kaufman Library at Georgia Gwinnett College"
                  className="img-fluid rounded mx-auto"
                />
              </div>
              <div className="col-md-6 p-3 p-md-5">
                <h2>Injury Prevention</h2>
                <p className="lead" style={{ textAlign: "center" }}>
                  Learn tips and techniques to prevent injuries and stay active.
                </p>
                <AuthButton label="Injury Prevention" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Landing;
